import React, { createContext, useContext, useState, useCallback } from 'react'
import { toast } from 'react-hot-toast'

const ToastContext = createContext()

export const useToast = () => {
  const context = useContext(ToastContext)
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider')
  }
  return context
}

export const ToastProvider = ({ children }) => {
  const showSuccess = useCallback((message, options = {}) => {
    toast.success(message, {
      style: {
        background: '#3b82f6',
        color: '#fff',
        borderRadius: '8px',
        padding: '12px 16px',
        fontSize: '14px',
        fontWeight: '500',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      },
      iconTheme: {
        primary: '#fff',
        secondary: '#3b82f6',
      },
      ...options
    })
  }, [])

  const showError = useCallback((message, options = {}) => {
    toast.error(message, {
      style: {
        background: '#3b82f6',
        color: '#fff',
        borderRadius: '8px',
        padding: '12px 16px',
        fontSize: '14px',
        fontWeight: '500',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      },
      iconTheme: {
        primary: '#fff',
        secondary: '#3b82f6',
      },
      ...options
    })
  }, [])

  const showInfo = useCallback((message, options = {}) => {
    toast(message, {
      style: {
        background: '#3b82f6',
        color: '#fff',
        borderRadius: '8px',
        padding: '12px 16px',
        fontSize: '14px',
        fontWeight: '500',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      },
      icon: 'ℹ️',
      ...options
    })
  }, [])

  const showWarning = useCallback((message, options = {}) => {
    toast(message, {
      icon: '⚠️',
      style: {
        background: '#3b82f6',
        color: '#fff',
        borderRadius: '8px',
        padding: '12px 16px',
        fontSize: '14px',
        fontWeight: '500',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      },
      ...options
    })
  }, [])

  const showLoading = useCallback((message, options = {}) => {
    return toast.loading(message, {
      style: {
        background: '#3b82f6',
        color: '#fff',
        borderRadius: '8px',
        padding: '12px 16px',
        fontSize: '14px',
        fontWeight: '500',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      },
      ...options
    })
  }, [])

  const dismiss = useCallback((toastId) => {
    toast.dismiss(toastId)
  }, [])

  const dismissAll = useCallback(() => {
    toast.dismiss()
  }, [])

  return (
    <ToastContext.Provider value={{
      showSuccess,
      showError,
      showInfo,
      showWarning,
      showLoading,
      dismiss,
      dismissAll
    }}>
      {children}
    </ToastContext.Provider>
  )
}